exports = module.exports = require("../../../../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tvb-button{display:flex;justify-content:center;align-items:center;user-select:none}.tvb-button-scale{transition:transform .15s linear}.tvb-button-scale:active{transform:scale(.95)}.tvb-button-brightness{transition:filter .1s}.tvb-button-brightness:active{filter:brightness(80%)}.tvb-button-disabled:active{filter:none;transform:none}", ""]);

// exports
